<form (ngSubmit)="onSubmit()" name="form" #myForm="ngForm" enctype="multipart/form-data">
  <div class="alert alert-success" *ngIf="alertSuccess">
    Chapter saved successfully!
  </div>
  <div class="alert alert-danger" *ngIf="alertFailure">
    Chapter already exists!
  </div>
  <div class="alert alert-success" *ngIf="alertUpdate">
    Chapter updated successfully!
  </div>
  <div class="alert alert-danger" *ngIf="timeOutError">
    {{timeoutErrorMessage}}
  </div>
  <p class="alert alert-danger" *ngIf="errorMessageActive">{{errorMessage}}</p>
  <div class="chapter-container">
   
    <div *ngIf="adminId == 1" [ngClass]="{'admin-div': !ischapterEdit}">
      <!-- <h5 style="margin-top:10px">CHAPTERS LIST</h5> -->
      <div class="col-md-12 col-xs-12 col-sm-12 heading mt-4 mb-4">
        <span class="span-create-edit-hoshin color">CHAPTERS LIST</span>
        <span class="pt-2" style="font-size: 13px;"><a href="assets/userguides/ChapterScreenUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
      </div>
     </div>

     
      
      <button *ngIf="adminId == 1 && !ischapterEdit" class="btn btn-danger chapter-button" (click)="createChapterClick()">CREATE CHAPTER</button>
  

    <div *ngIf="((adminId == 2 || adminId == 3 || isbpgAdmin || isbpgLeadAdmin) && ischapterEdit)">
      <h5>EDIT CHAPTER <h6 class="star">{{siteName}} - {{bpgName}}</h6>
        <!-- <div class="col-md-12 col-xs-12 col-sm-12 heading p-0 mt-4 mb-4">
          <span class="span-create-edit-hoshin color">EVENT REPORT</span>
          <span class="pt-2" style="font-size: 13px;"><a href="assets/userguides/EventReportUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
        </div> -->
      </h5>
    </div>

    <div class="col-md-3 divfloat"
      [hidden]="!((adminId == 1 || adminId ==2 || adminId ==3 || isbpgAdmin || isbpgLeadAdmin) && ischapterEdit)">
      <ul class="nav flex-column nav-pills" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="pill" href="#home" (click)="hideErrorMessaage('Banner')">Banner
            Image</a>
        </li>
        <li class="nav-item">
          <a class="nav-link " data-toggle="pill" href="#menu1" [ngClass]="{'pointerDisable': showFirstTab == false}"
            (click)="hideErrorMessaage('Vision')">Vision &
            Mission</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="pill" href="#menu2" [ngClass]="{'pointerDisable': showSecondTab == false}"
            (click)="hideErrorMessaage('Leadership')">Leadership</a>
        </li>
      </ul>
    </div>
    <div class="tab-content divfloat col-md-8"
      [hidden]="!((adminId == 1 || adminId ==2 || adminId ==3 || isbpgAdmin || isbpgLeadAdmin) && ischapterEdit)">
      <div id="home" class="container tab-pane active">
        <!-- banner image tab starts -->
        <div>
          <div>
            <label class="sitelabel" for="siteName">Select Site<span class="star"> *</span></label>
            <select [disabled]="butDisabled" class="form-control-inline" id="siteName" name="siteName"
              (change)="findSiteId($event, siteName)" [(ngModel)]="siteName" required>
              <option value="{{siteName}}">Select Site</option>
              <option *ngFor="let site of siteList" [ngValue]="site.siteName">{{site.siteName}}</option>
            </select>
          </div>
          <div>
            <label class="sitelabel" for="bpgName">Select ERG<span class="star"> *</span></label>
            <select [disabled]="butDisabled" class="form-control-inline" id="bpgName" name="bpgName"
              (change)="findBpgId($event, bpgName)" [(ngModel)]="bpgName" required>
              <option value="{{bpgName}}">Select ERG</option>
              <option *ngFor="let bpg of bpgList" [ngValue]="bpg.bpgName">{{bpg.bpgName}}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="sitelabel bannerupload" for="chapterBanner">Select Image <span class="star"> *</span></label>
          <input #myInputBannerImage type="file" class="form-control inputfile inputfile-6" id="chapterBanner"
            name="chapterBanner" [(ngModel)]="chapterBanner" maxlength="200"
            (change)="fileChangeEvent($event, 'bannerImage')" accept="image/*" [required]="chapterId == '0'"
            [attr.disabled]="isUploadBannerImage == true ? true : null">
          <label for="chapterBanner" class="ellipsis-image"><span id="bannerfilename" class="banner-width">JPEG or
              PNG</span><strong><img *ngIf="!isUploadBannerImage" alt="Angular Logo"
                src="assets/images/upload-button.png" /></strong></label>
          <textarea class="base64textarea" id="base64textarea"></textarea>
        </div>
        <div>
          <label class="sitelabel" for="chapterEmail">Chapter Email ID<span class="star"> *</span></label>
          <input placeholder=" Enter Chapter Email Address" class="form-control-inline" id="chapterEmail"
            (keyup)="checkEmailType($event)" name="chapterEmail" [(ngModel)]="chapterEmail" required>


        </div>
        <div>
          <label class="sitelabel" for="bpgDate">ERG Established Date</label>
          <input placeholder=" Enter ERG Established Date" [disabled]="butDisabled" bsDatepicker
            class="form-control-inline date-icon" id="bpgDate" name="bpgDate" [(ngModel)]="bpgDate">
        </div>

        <div *ngIf="(adminId==1)">
          <label class="sitelabel" for="setStatus">Status<span class="star"> *</span></label>
          <input type="radio" class="radio-input-align" name="setStatus" checked (click)=setActiveStatus()> Active
          <input type="radio" class="radio-input-align radio-input-margin" name="setStatus" value=false
            (click)=setInactiveStatus()> Inactive
        </div>

        <div class="form-group" *ngIf="isUploadBannerImage">
          <span class="sitelabel" for="siteBanner"></span>
          <div class="pull-left">
            <div class="loader_ajax_small" [hidden]="isUploadBannerLoaderStop"></div>
            <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="1366/400" [maintainAspectRatio]="true"
              [resizeToWidth]="1366" [resizeToHeight]="400" [onlyScaleDown]="true" format="png"
              (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()" [imageQuality]="92"></image-cropper>
          </div>
        </div>
        <div class="form-group" *ngIf="isUploadBannerLoaderStop">
          <span class="sitelabel bannerupload" for="siteBanner"></span>
          <div class="pull-left">
            <a (click)="doneUploadedImage('bannerImage')"><span class="uploadImageClass"><i
                  class="fa fa-check"></i>&nbsp;Done</span></a>
            &nbsp;&nbsp;<a (click)="cancelUploadedImage('bannerImage')"><span class="uploadImageClass"><i
                  class="fa fa-close"></i>&nbsp;Cancel</span></a>
          </div>
        </div>


        <!-- banner Image tab close -->
      </div>


      <div id="menu1" class="container tab-pane fade">
        <!-- vision-mission tab starts -->
        <div class="form-group">
          <label class="statement label-width" name="visionStmt" id="vision-lbl">Vision Statement
            <span class="star"> *</span><br>
            <span class="validation-error-message" *ngIf="chapterVision != null && chapterVision.length>=1024">
              Only a maximum of 1024 characters are allowed
            </span>
          </label>
          <div class="ckeditor-style val-margin">
            <ckeditor (change)="enableTab('second')" [(ngModel)]="chapterVision" #myckeditor="ngModel"
              name="chapterVision" maxlength="1024" [config]="removeToolbar" [readonly]="false" required>
            </ckeditor>
          </div>

        </div>

        <div class="form-group">
          <label class="statement label-width" name="missionStmt" id="mission-lbl">Mission Statement
            <span class="star"> *</span><br>
            <span class="validation-error-message" *ngIf="chapterMission != null && chapterMission.length>=1024">
              Only a maximum of 1024 characters are allowed
            </span>
          </label>
          <div class="ckeditor-style val-margin">
            <ckeditor (change)="enableTab('second')" [(ngModel)]="chapterMission" #myckeditor="ngModel"
              name="chapterMission" maxlength="1024" [config]="removeToolbar" [readonly]="false" required>
            </ckeditor>
          </div>

        </div>

        
        <!-- vision-mission tab close -->
      </div>


      <div id="menu2" class="container tab-pane fade">
        <!-- Leadership tab starts -->

        <!-- Executive sponser section -->
        <div class="form-group leadership">
          <label class="sitelabel">Executive Sponsor</label>

          <div class="chapterSelection leadership-width">
            <div class="form-group email">
              <ng-select placeholder ="Select User" name = "sponserName"  style= "width:100%" [items] = "userListForExecSponser" bindLabel ="userFirstName" [(ngModel)]="sponserName" (change)="userSelectionForExecSponser($event)" (keyup)="findbyEmail($event)" >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div>{{item.userFirstName}} {{item.userLastName}}</div>
                
                </ng-template>
              </ng-select> 
            </div>
            <div class="form-group email">
              <input type="text" class="form-control leadershipEmail" id="sponserPronoun" placeholder="Pronoun"
                name="sponserPronoun" maxlength="50" [(ngModel)]="sponserPronoun">
            </div>
            <div class="form-group leadership" [ngClass]="{'DisableChair':(sponserName == null || sponserName == '')}">
              <input #myInputExecutiveSponserImage type="file" class="form-control inputfile inputfile-6"
                id="executiveSponser" name="executiveSponser" [(ngModel)]="executiveSponser" maxlength="200"
                (change)="fileChangeEvent($event, 'sponserImage')" accept="image/*"
                [attr.disabled]="isUploadExecutiveSponsorImage == true ? true : null">
              <label class="leadershipImage ellipsis-image" for="executiveSponser"><span id="executiveSponserfilename"
                  class="banner-width">JPEG or PNG</span><strong><img *ngIf="!isUploadExecutiveSponsorImage"
                    alt="Angular Logo" src="assets/images/upload-button.png" /></strong></label>
              <a class="deleteButton delete-button-style zoom-in-style" data-toggle="modal" data-target="#myModal"
                (click)="removeFile('executiveSponser')">
                <img src="assets/images/delete.png" alt="Angular Logo" class="image"></a>
              <textarea class="base64textarea" id="base64textareaExecutiveSponser"></textarea>
            </div>

            <div class="form-group leadership" *ngIf="isUploadExecutiveSponsorImage">
              <div class="pull-left">
                <div class="loader_ajax_small" [hidden]="isUploadExecutiveSponsorLoaderStop"></div>
                <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="400/400"
                  [maintainAspectRatio]="true" [resizeToWidth]="400" [resizeToHeight]="400" [onlyScaleDown]="true"
                  format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                  (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()" [imageQuality]="92">
                </image-cropper>
              </div>
            </div>
            <div class="form-group leadership" *ngIf="isUploadExecutiveSponsorLoaderStop">
              <div class="pull-left pull-left-text">
                <a (click)="doneUploadedImage('sponserImage')"><span class="uploadImageClass"><i
                      class="fa fa-check"></i>&nbsp;Done</span></a>
                &nbsp;&nbsp;<a (click)="cancelUploadedImage('sponserImage')"><span class="uploadImageClass"><i
                      class="fa fa-close"></i>&nbsp;Cancel</span></a>
              </div>
            </div>

            <div class="form-group email" [ngClass]="{'DisableChair':(sponserName == null || sponserName == '')}">
              <input type="email"  class="form-control leadershipEmail"
                id="sponsorEmailId" placeholder="Email Id" name="sponsorEmailId" maxlength="100"
                [(ngModel)]="sponsorEmailId" [readonly]>
            </div>


          </div>
        </div>

        <!-- CHAIR SECTION    -->

        <div class="form-group leadership">
          <label class="sitelabel">Chair</label>
          <div class="chapterSelection leadership-width">
            <select class="form-control margin-image" id="userId1" name="userId1" [(ngModel)]="userId1"
              (change)="chairSelection($event)" placeholder="select chair" (click)="createChair()">
              <option value=null>Select Chair</option>
              <option *ngFor="let user of leadershipChairList" value="{{user.userId}}">{{user.userFirstName}}
                {{user.userLastName}}</option>
            </select>
            <div class="form-group email">
              <input type="text" class="form-control leadershipEmail" id="chairPronoun" placeholder="Pronoun"
                name="chairPronoun" maxlength="50" [(ngModel)]="chairPronoun">
            </div>
            <div class="form-group leadership" [ngClass]="{'DisableChair':(userId1 == null || userId1 == '')}">
              <input #myInputChairImage type="file" class="form-control inputfile inputfile-6" id="chairImage"
                name="chairImage" [(ngModel)]="chairImage" maxlength="200"
                (change)="fileChangeEvent($event, 'chairImage')"
                [attr.disabled]="isUploadChairImage == true ? true : null">
              <label class="leadershipImage ellipsis-image" for="chairImage"><span id="chairfilename"
                  class="banner-width">JPEG or PNG</span><strong><img *ngIf="!isUploadChairImage" alt="Angular Logo"
                    src="assets/images/upload-button.png" /></strong></label>
              <a class="deleteButton delete-button-style zoom-in-style" data-toggle="modal" data-target="#myModal"
                (click)="removeFile('chairfilename')">
                <img src="assets/images/delete.png" alt="Angular Logo" class="image"></a>
              <textarea class="base64textarea" id="base64textareaChair"></textarea>
            </div>

            <div class="form-group leadership" *ngIf="isUploadChairImage">
              <div class="pull-left">
                <div class="loader_ajax_small" [hidden]="isUploadChairLoaderStop"></div>
                <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="400/400"
                  [maintainAspectRatio]="true" [resizeToWidth]="400" [resizeToHeight]="400" [onlyScaleDown]="true"
                  format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                  (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()" [imageQuality]="92">
                </image-cropper>
              </div>
            </div>
            <div class="form-group leadership" *ngIf="isUploadChairLoaderStop">
              <div class="pull-left pull-left-text">
                <a (click)="doneUploadedImage('chairImage')"><span class="uploadImageClass"><i
                      class="fa fa-check"></i>&nbsp;Done</span></a>
                &nbsp;&nbsp;<a (click)="cancelUploadedImage('chairImage')"><span class="uploadImageClass"><i
                      class="fa fa-close"></i>&nbsp;Cancel</span></a>
              </div>
            </div>
            <div class="form-group email">
              <input type="email" (keyup)="onEmailType($event,'CHAIR')"
                [ngClass]="{'DisableChair':(userId1 == null || userId1 == '')}" class="form-control leadershipEmail"
                id="chairEmailId" placeholder="Email Id" name="chairEmailId" maxlength="100" [(ngModel)]="chairEmailId">
            </div>
          </div>
        </div>

        <!-- VICE CHAIR SECTION    -->

        <div class="form-group leadership">
          <label class="sitelabel">Vice Chair</label>
          <div class="chapterSelection leadership-width">
            <select class="form-control margin-image" id="userId2" name="userId2" [(ngModel)]="userId2"
              (change)="viceChairSelection($event)" (click)="createChair()">
              <option value=null>Select Vice Chair</option>
              <option *ngFor="let user of leadershipViceChairList" value="{{user.userId}}">{{user.userFirstName}}
                {{user.userLastName}}</option>
            </select>
            <div class="form-group email">
              <input type="text" class="form-control leadershipEmail" id="viceChairPronoun" placeholder="Pronoun"
                name="viceChairPronoun" maxlength="50" [(ngModel)]="viceChairPronoun">
            </div>
            <div class="form-group leadership" [ngClass]="{'DisableViceChair':(userId2 == null || userId2 == '')}">
              <input #myInputViseChairImage type="file" class="form-control inputfile inputfile-6" id="viceChairImage"
                name="viceChairImage" [(ngModel)]="viceChairImage" maxlength="200"
                (change)="fileChangeEvent($event, 'viceChairImage')"
                [attr.disabled]="isUploadViseChairImage == true ? true : null">
              <label class="leadershipImage ellipsis-image" for="viceChairImage"><span id="vicechairfilename"
                  class="banner-width">JPEG or PNG</span><strong><img *ngIf="!isUploadViseChairImage"
                    alt="Angular Logo" src="assets/images/upload-button.png" /></strong></label>
              <a class="deleteButton delete-button-style zoom-in-style" data-toggle="modal" data-target="#myModal"
                (click)="removeFile('viceChairImage')">
                <img src="assets/images/delete.png" alt="Angular Logo" class="image"></a>
              <textarea class="base64textarea" id="base64textareaViceChair"></textarea>
            </div>

            <div class="form-group leadership" *ngIf="isUploadViseChairImage">
              <div class="pull-left pull-left-text">
                <div class="loader_ajax_small" [hidden]="isUploadViseChairLoaderStop"></div>
                <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="400/400"
                  [maintainAspectRatio]="true" [resizeToWidth]="400" [resizeToHeight]="400" [onlyScaleDown]="true"
                  format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                  (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()" [imageQuality]="92">
                </image-cropper>
              </div>
            </div>
            <div class="form-group leadership" *ngIf="isUploadViseChairLoaderStop">
              <div class="pull-left">
                <a (click)="doneUploadedImage('viceChairImage')"><span class="uploadImageClass"><i
                      class="fa fa-check"></i>&nbsp;Done</span></a>
                &nbsp;&nbsp;<a (click)="cancelUploadedImage('viceChairImage')"><span class="uploadImageClass"><i
                      class="fa fa-close"></i>&nbsp;Cancel</span></a>
              </div>
            </div>

            <div class="form-group email">
              <input type="email" (keyup)="onEmailType($event,'VICE CHAIR')"
                [ngClass]="{'DisableChair':(userId2 == null || userId2 == '')}" class="form-control leadershipEmail"
                id="viceChairEmailId" placeholder="Email Id" name="viceChairEmailId" maxlength="100"
                [(ngModel)]="viceChairEmailId">
            </div>
          </div>
        </div>

        <!-- Finance CHAIR SECTION    -->

        <div class="form-group leadership">
          <label class="sitelabel">Finance Chair</label>
          <div class="chapterSelection leadership-width">
            <select class="form-control margin-image" id="userId3" name="userId3" [(ngModel)]="userId3"
              (change)="financeChairSelection($event)" (click)="createChair()">
              <option value=null>Select Finance Chair</option>
              <option *ngFor="let user of leadershipFinanceChairList" value="{{user.userId}}">{{user.userFirstName}}
                {{user.userLastName}}</option>
            </select>
            <div class="form-group email">
              <input type="text" class="form-control leadershipEmail" id="financeChairPronoun" placeholder="Pronoun"
                name="financeChairPronoun" maxlength="50" [(ngModel)]="financeChairPronoun">
            </div>
            <div class="form-group leadership" [ngClass]="{'DisableFinanceChair':(userId3 == null || userId3 == '')}">
              <input #myInputFinanceChairImage type="file" class="form-control inputfile inputfile-6"
                id="financeChairImage" name="financeChairImage" [(ngModel)]="financeChairImage" maxlength="200"
                (change)="fileChangeEvent($event, 'financeChairImage')"
                [attr.disabled]="isUploadFinanceChairImage == true ? true : null">
              <label class="leadershipImage ellipsis-image" for="financeChairImage"><span id="financechairfilename"
                  class="banner-width">JPEG or PNG</span><strong><img *ngIf="!isUploadFinanceChairImage" alt="Angular Logo"
                    src="assets/images/upload-button.png" /></strong></label>
              <a class="deleteButton delete-button-style zoom-in-style" data-toggle="modal" data-target="#myModal"
                (click)="removeFile('financeChairImage')">
                <img src="assets/images/delete.png" alt="Angular Logo" class="image"></a>
              <textarea class="base64textarea" id="base64textareaFinanceChair"></textarea>
            </div>
            <div class="form-group leadership" *ngIf="isUploadFinanceChairImage">
              <div class="pull-left">
                <div class="loader_ajax_small" [hidden]="isUploadFinanceChairLoaderStop"></div>
                <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="400/400"
                  [maintainAspectRatio]="true" [resizeToWidth]="400" [resizeToHeight]="400" [onlyScaleDown]="true"
                  format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                  (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()" [imageQuality]="92">
                </image-cropper>
              </div>
            </div>
            <div class="form-group leadership" *ngIf="isUploadFinanceChairLoaderStop">
              <div class="pull-left pull-left-text">
                <a (click)="doneUploadedImage('financeChairImage')"><span class="uploadImageClass"><i
                      class="fa fa-check"></i>&nbsp;Done</span></a>
                &nbsp;&nbsp;<a (click)="cancelUploadedImage('financeChairImage')"><span class="uploadImageClass"><i
                      class="fa fa-close"></i>&nbsp;Cancel</span></a>
              </div>
            </div>

            <div class="form-group email">
              <input type="email" (keyup)="onEmailType($event,'FINANCE CHAIR')"
                [ngClass]="{'DisableChair':(userId3 == null || userId3 == '')}" class="form-control leadershipEmail"
                id="financeChairEmailId" placeholder="Email Id" name="financeChairEmailId" maxlength="100"
                [(ngModel)]="financeChairEmailId">
            </div>
          </div>
        </div>

        <!-- Communications CHAIR SECTION    -->

        <div class="form-group leadership">
          <label class="sitelabel">Communication Chair</label>
          <div class="chapterSelection leadership-width">
            <select class="form-control margin-image" id="userId4" name="userId4" [(ngModel)]="userId4"
              (change)="communicationChairSelection($event)" (click)="createChair()">
              <option value=null>Select Communication Chair</option>
              <option *ngFor="let user of leadershipCommunicationChairList" value="{{user.userId}}">
                {{user.userFirstName}} {{user.userLastName}}</option>
            </select>
            <div class="form-group email">
              <input type="text" class="form-control leadershipEmail" id="communicationChairPronoun"
                placeholder="Pronoun" name="communicationChairPronoun" maxlength="50"
                [(ngModel)]="communicationChairPronoun">
            </div>
            <div class="form-group leadership"
              [ngClass]="{'DisableCommunicationChair':(userId4 == null || userId4 == '')}">
              <input #myInputCommunicationChairImage type="file" class="form-control inputfile inputfile-6"
                id="communicationChairImage" name="communicationChairImage" [(ngModel)]="communicationChairImage"
                maxlength="200" (change)="fileChangeEvent($event,'communicationChairImage')"
                [attr.disabled]="isUploadCommunicationChairImage == true ? true : null">
              <label class="leadershipImage ellipsis-image" for="communicationChairImage"><span
                  id="communicationchairfilename" class="banner-width">JPEG or PNG</span><strong><img
                    *ngIf="!isUploadCommunicationChairImage" alt="Angular Logo" src="assets/images/upload-button.png" /></strong></label>
              <a class="deleteButton delete-button-style zoom-in-style" data-toggle="modal" data-target="#myModal"
                (click)="removeFile('communicationChairImage')">
                <img src="assets/images/delete.png" class="image" alt="Angular Logo"></a>
              <textarea class="base64textarea" id="base64textareaCommunicationChair"></textarea>
            </div>
            <div class="form-group leadership" *ngIf="isUploadCommunicationChairImage">
              <div class="pull-left">
                <div class="loader_ajax_small" [hidden]="isUploadCommunicationChairLoaderStop"></div>
                <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="400/400"
                  [maintainAspectRatio]="true" [resizeToWidth]="400" [resizeToHeight]="400" [onlyScaleDown]="true"
                  format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                  (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()" [imageQuality]="92">
                </image-cropper>
              </div>
            </div>
            <div class="form-group leadership" *ngIf="isUploadCommunicationChairLoaderStop">
              <div class="pull-left pull-left-text">
                <a (click)="doneUploadedImage('communicationChairImage')"><span class="uploadImageClass"><i
                      class="fa fa-check"></i>&nbsp;Done</span></a>
                &nbsp;&nbsp;<a (click)="cancelUploadedImage('communicationChairImage')"><span
                    class="uploadImageClass"><i class="fa fa-close"></i>&nbsp;Cancel</span></a>
              </div>
            </div>
            <div class="form-group email">
              <input type="email" (keyup)="onEmailType($event,'COMMUNICATION CHAIR')"
                [ngClass]="{'DisableChair':(userId4 == null || userId4 == '')}" class="form-control leadershipEmail"
                id="commChairEmailId" placeholder="Email Id" name="commChairEmailId" maxlength="100"
                [(ngModel)]="commChairEmailId">
            </div>
          </div>
        </div>
        <!-- CHAPTER BOARD    -->
        <div *ngFor="let member of chapterBoardList; let j=index;">
          <div class="form-group leadership">

            <label class="sitelabel">{{member.designation}}<br><br>
              <a id="editRt{{j}}" (click)="editBoardData(member)" class="edit-delete"><img src="assets/images/edit.png" alt="Angular Logo"
                  class="image" title="Edit"></a>
              <a class="edit-delete" id=deleteBoard{{j}} (click)="deleteBoard(member.chapterBoardId,j)"><img
                  src="assets/images/delete.png" class="image" alt="Angular Logo" title="Delete"></a>
            </label>
            <div class="chapterSelection leadership-width">

              <div class="form-group email">
                <input type="text" class="form-control leadershipEmail" id="userName{{j}}" placeholder="Name"
                  name="userName{{j}}" [(ngModel)]="member.userName" [readonly]="true">
              </div>
              <div class="form-group email">
                <input type="text" class="form-control leadershipEmail" id="pronoun{{j}}" placeholder="Pronoun"
                  name="pronoun{{j}}" [(ngModel)]="member.pronoun" [readonly]="true">
              </div>
              <div class="form-group email">
                <input type="text" class="form-control leadershipEmail" id="userPic{{j}}" placeholder="JPEG or PNG"
                  name="userPic{{j}}" [(ngModel)]="member.userPic" [readonly]="true">
              </div>

              <div class="form-group email">
                <input type="email" class="form-control leadershipEmail" id="emailId{{j}}" placeholder="Email Id"
                  name="emailId{{j}}" [readonly]="true" [(ngModel)]="member.emailId">
              </div>
            </div>

          </div>
        </div>

        <u *ngIf="(siteId!='' && bpgId!='')" class="other-role" (click)="openAndCloseMatDialog('open')">Click here to
          add new
          roles</u>
        <br>
        <br>
        <!-- Leadership tab close -->
      </div>
    </div>


    <div class="clear"></div>
    <p class="errorMessage" *ngIf="leadershipChairDuplicateCheck"> {{duplicateMessage}} </p>
    <p class="errorMessage" *ngIf="uploadFileExtension"> You can only upload jpg, jpeg, png files</p>
    <p class="errorMessage" *ngIf="uploadFileBannerExtension"> You can only upload jpg, jpeg, png files having width >
      1366 px </p>
    <p class="errorMessage" *ngIf="uploadLeadershipChairFileExtension"> You can only upload jpg, jpeg, png files having
      width & height equal to 400 px </p>
    <p class="errorMessage" *ngIf="uploadLeadershipViceChairFileExtension"> You can only upload jpg, jpeg, png files
      having width & height equal to 400 px </p>
    <p class="errorMessage" *ngIf="uploadLeadershipFinanceChairFileExtension"> You can only upload jpg, jpeg, png files
      having width & height equal to 400 px </p>
    <p class="errorMessage" *ngIf="uploadLeadershipCommunicationChairFileExtension"> You can only upload jpg, jpeg, png
      files having width & height equal to 400 px </p>
    <p class="errorMessage" *ngIf="uploadExecutiveSponserFileExtension"> You can only upload jpg, jpeg, png files having
      width & height equal to 400 px </p>
    <p class="errorMessage" *ngIf="visionBlankCheck"> Please fill out all the mandatory fields!</p>
    <p class="errorMessage" *ngIf="invalidChairEmail">Incorrect email format for Chair!</p>
    <p class="errorMessage" *ngIf="invalidViceChairEmail">Incorrect email format for Vice Chair!</p>
    <p class="errorMessage" *ngIf="invalidFinanceChairEmail">Incorrect email format for Finance Chair!</p>
    <p class="errorMessage" *ngIf="invalidCommChairEmail">Incorrect email format for Communication Chair!</p>
    <p class="errorMessage" *ngIf="invalidExecutiveSponsorEmail">Incorrect email format for Executive Sponsor!</p>
    <p class="errorMessage" *ngIf="isChairEmailBlank">Chair email id is required!</p>
    <p class="errorMessage" *ngIf="isViceEmailBlank">Vice chair email id is required!</p>
    <p class="errorMessage" *ngIf="isFinanceEmailBlank">Finance chair email id is required!</p>
    <p class="errorMessage" *ngIf="isCommEmailBlank">Communication chair email id is required!</p>
    <p class="errorMessage" *ngIf="isSponsorEmailBlank">Executive sponsor email id is required!</p>
    <p class="errorMessage" *ngIf="chapterEmailInvalid">Invalid email format</p>
    <span class="respone-hide initiative-style"
      *ngIf="((adminId == 1 || adminId ==2 || adminId ==3 || isbpgAdmin || isbpgLeadAdmin) && ischapterEdit)">
<div style="display:inline-flex">
  <div>
      <span
        *ngIf="siteName == 'Select Site' || bpgName == 'Select ERG' || bannerFileName == null || bannerFileName == '' || chapterEmail == null || chapterEmail == '' || chapterVision == null ||  chapterVision == '' || chapterMission == null || chapterMission == ''">Missing
        fields</span>
  </div>
  <div style="margin-left:6vw">
      <div>
        <span *ngIf="siteName == 'Select Site' || bpgName == 'Select ERG'  || bannerFileName == null ||bannerFileName == ''
        || chapterEmail == null || chapterEmail == ''"><b>Banner Image : </b></span>
        <span *ngIf="siteName == 'Select Site'">Site</span>
        <span
          *ngIf="(bpgName == 'Select ERG'  || bannerFileName == null ||bannerFileName == ''
      || chapterEmail == null || chapterEmail == '' || chapterVision == null || chapterVision == '' || chapterMission == null || chapterMission == '')"
          [hidden]="siteName != 'Select Site'">,</span>
        <span *ngIf="bpgName == 'Select ERG'"> ERG</span>
        <span [hidden]="bpgName != 'Select ERG'"
          *ngIf="(bannerFileName == null || bannerFileName == ''
      || chapterEmail == null || chapterEmail == '' || chapterVision == null ||  chapterVision == '' || chapterMission == null || chapterMission == '')">,</span>

        <span *ngIf="bannerFileName == null || bannerFileName == ''"> Image</span>
        <span [hidden]="bannerFileName != null && bannerFileName != ''"
          *ngIf="(chapterEmail == null || chapterEmail == '' || chapterVision == null || chapterVision == ''|| chapterMission == null || chapterMission == '')">,</span>
        <span *ngIf="chapterEmail == null || chapterEmail == ''"> Chapter Email</span>
      </div>
      <div>
        <span *ngIf="chapterVision == null || chapterVision == '' || chapterMission == null || chapterMission == ''">
          <b>Vision & Mission : </b></span>
        <span *ngIf="chapterVision == null || chapterVision == ''"> Chapter Vision</span>
        <span [hidden]="chapterVision != null && chapterVision != ''"
          *ngIf="(chapterMission == null || chapterMission == '')">,</span>

        <span *ngIf="chapterMission == null || chapterMission == ''"> Chapter Mission</span>
      </div>
    </div>
  </div>
    </span>
    <div class="btn-div"
    *ngIf="((adminId == 1 || adminId ==2 || adminId ==3 || isbpgAdmin || isbpgLeadAdmin) && ischapterEdit)">

      <button type="submit" class="btn btn-danger" *ngIf="editandSavebtn ==false && savebtn == true"
        [disabled]="chapterEmailInvalid || !myForm.valid || uploadFileExtension || uploadBannerImageDone || isUploadAllImageDone || invalidChairEmail || invalidViceChairEmail || invalidFinanceChairEmail || invalidCommChairEmail || invalidExecutiveSponsorEmail || isChairEmailBlank || isViceEmailBlank || isFinanceEmailBlank || isCommEmailBlank || isSponsorEmailBlank"
        data-toggle="modal" data-target="#myModal">SAVE</button>
      <button type="submit" class="btn btn-danger" *ngIf="editandSavebtn ==true && savebtn == false"
        [disabled]="chapterEmailInvalid || !myForm.valid || uploadFileExtension || uploadBannerImageDone || isUploadAllImageDone || invalidChairEmail || invalidViceChairEmail || invalidFinanceChairEmail || invalidCommChairEmail || invalidExecutiveSponsorEmail || isChairEmailBlank || isViceEmailBlank || isFinanceEmailBlank || isCommEmailBlank || isSponsorEmailBlank"
        data-toggle="modal" data-target="#myModal">SAVE AND UPDATE</button>
      <button type="button" class="btn btn-danger" (click)="resetChapter()" data-toggle="modal"
        data-target="#myModal">RESET</button>
      <button type="button" class="btn btn-danger" (click)="cancelChapter()"
        *ngIf="( adminId == 1 && ischapterEdit || ((adminId == 2 || adminId == 3 || isbpgAdmin || isbpgLeadAdmin) && ischapterEdit))">CANCEL</button>
    </div>
  </div>
  <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
</form>

<div class="outer-div">
  <div class="searchBox">
    <label for="search">Search</label>
    <input type="text" class="form-control" id="search" maxlength="50" placeholder="Keywords here"
      [(ngModel)]="searchKey" (keyup.enter)="searchMe()">
  </div>
</div>

<!--table-->
<p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
<div class="table-container" *ngIf="tableShow">
  <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
    <thead>
      <tr class="tr-th">
        <th scope="col" (click)="sortMe('s.site_name')">Site <span class="sortupdown"><i id="s.site_name1"
              class="fa fa-sort-up"></i><i id="s.site_name2" class="fa fa-sort-down"></i></span></th>
        <th scope="col" (click)="sortMe('b.bpg_name')">ERG <span class="sortupdown"><i id="b.bpg_name1"
              class="fa fa-sort-up"></i><i id="b.bpg_name2" class="fa fa-sort-down"></i></span></th>
        <th scope="col">Vision Statement</th>
        <th scope="col">Mission Statement</th>
        <th scope="col">Status</th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let data of chapterData | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
        <td>{{data.siteName}}</td>
        <td>{{data.bpgName}}</td>
        <td><span
            [innerHtml]="data.chapterVision.length > 125 ? data.chapterVision.slice(0,125)+'...' : data.chapterVision"></span>
        </td>
        <td><span
            [innerHtml]="data.chapterMission.length > 125 ? data.chapterMission.slice(0,125)+'...' : data.chapterMission"></span>
        </td>
        <td *ngIf="data.isActive">Active </td>
        <td *ngIf="!(data.isActive)">Inactive </td>

        <td>
          <a id="edit{{i}}" (click)="edit(data,i)" class="edit-delete"><img src="assets/images/edit.png" class="image" alt="Angular Logo"
              title="Edit"></a>
        </td>
      </tr>
    </tbody>
  </table>
  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>

</div>
<ng-template #callAPIDialog>

  <div class="alert alert-danger" *ngIf="noUserChapterBoard">
    No user found !
  </div>
  <div class="alert alert-success" *ngIf="userFoundChapterBoard">
    Please select from user dropdown
  </div>
  <div class="alert alert-success" *ngIf="chapterMemberSuccess && saveBoard">
    Chapter member saved successfully!
  </div>

  <div class="alert alert-success" *ngIf="chapterMemberSuccess && saveAndUpdateBoard">
    Chapter member updated successfully!
  </div>
  <div class="alert alert-success" *ngIf="deleteChapterBoardMember">
    Chapter member deleted successfully!
  </div>
  <div class="alert alert-danger" *ngIf="errorMessageActiveChapterBoard">{{errorMessageChapterBoard}}
  </div>

  <div>
    <h5>MANAGE CHAPTER BOARD</h5>
  </div>
  <div class="container tab-pane">
    
    <form (ngSubmit)="onChapterBoardSubmit()" class="padding-class" onkeypress="return !(event.charCode == 13)"
      action="" name="chapterBoardForm" #chapterBoardForm="ngForm" enctype="multipart/form-data">


      <div class="form-group mt-3">
        <label class="sitelabel" for="userName">Name <span class="star"> *</span></label>
        <ng-select placeholder="Select user" name="userName" class="custom user-width" [items]="userList"
           bindLabel="userFirstName" Value="userId" (keyup)="findbyEmailId($event)"
          [(ngModel)]="userFirstName" (change)="userSelection($event)" required>
          <ng-template ng-option-tmp let-item="item" let-index="index">
            <div>{{item.userFirstName}}</div>
            <div *ngIf="item.division" style="font-size: 11px">{{item.division}}</div>
            <div *ngIf="item.classification" style="font-size: 11px">{{item.classification}}</div>
          </ng-template>
        </ng-select>
      </div>

      <div class="form-group">
        <label class="sitelabel" for="designation">Role Name <span class="star"> *</span></label>
        <input type="text" class="form-control" id="designation" name="designation" [(ngModel)]="designation"
          placeholder="Enter role name" required autocomplete="off" maxlength="50">
      </div>
      <div class="form-group">
        <label class="sitelabel" for="emailId">Email Id <span class="star"> *</span></label>
        <input type="text" class="form-control" id="emailId" name="emailId" [(ngModel)]="emailId"
          [readonly]="noUserChapterBoard || butDisabledChapterBoard" (keyup)="onEmailTypeChapterBoard($event)"
          placeholder="Enter email id" required maxlength="50">
      </div>
      <div class="form-group">
        <label class="sitelabel" for="pronoun">Pronouns </label>
        <input type="text" class="form-control" id="pronoun" name="pronoun" [(ngModel)]="pronoun"
          placeholder="Enter Pronouns" maxlength="50">

      </div>

      <div class="form-group">
        <label class="sitelabel bannerupload" for="userPic">Upload Image<span class="star"> *</span></label>
        <input #myInput type="file" class="form-control inputfileChapter  inputfile inputfile-6" id="userPic"
          name="userPic" maxlength="200" [(ngModel)]="userPic" (change)="fileChangeEventChapterBoard($event)"
          accept="image/*" [required]="userPic == null" [attr.disabled]="isUploadUserPicImage == true ? true : null">
        <label for="userPic" class="label-overflow"><span id="filenameUserPic"
            class="ellipsis">{{uploadFileNameUser}}</span><strong><img *ngIf="!isUploadUserPicImage" alt="Angular Logo"
              src="assets/images/upload-button.png" /></strong></label>
        <textarea class="form-control base64textarea" id="base64textareaUser"></textarea>
      </div>
      <div class="form-group" *ngIf="isUploadUserPicImage">
        <span class="sitelabel bannerupload" for="userPic"></span>
        <div class="pull-left">
          <div class="loader_ajax_small" [hidden]="isLoaderUserPicStop"></div>
          <image-cropper [imageChangedEvent]="imageChangedEventChapterBoard" [aspectRatio]="400/400"
            [maintainAspectRatio]="true" [resizeToWidth]="400" [resizeToHeight]="400" [onlyScaleDown]="true"
            format="png" (imageCropped)="imageCroppedChapterBoard($event)" (imageLoaded)="imageLoadedChapterBoard()"
            (cropperReady)="cropperReadyChapterBoard()" (loadImageFailed)="loadImageFailedChapterBoard()"
            [imageQuality]="92"></image-cropper>
        </div>
      </div>
      <div class="form-group" *ngIf="isLoaderUserPicStop">
        <span class="sitelabel bannerupload" for="userPic"></span>
        <div class="pull-left">
          <a (click)="doneUploadedImageChapterBoard('userPic')"><span class="uploadImageClass"><i
                class="fa fa-check"></i>&nbsp;Done</span></a>
          &nbsp;&nbsp;<a (click)="cancelUploadedImageChapterBoard('userPic')"><span class="uploadImageClass"><i
                class="fa fa-close"></i>&nbsp;Cancel</span></a>
        </div>
      </div>
      <div class="form-group">
        <label class="sitelabel" for="teamOrder">Order<span class="star"> *</span></label>
        <input type="number" class="form-control" id="teamOrder" name="teamOrder"
          onkeypress="return !((event.charCode == 46||event.charCode == 101||event.charCode == 69)) && (event.charCode >= 48 && event.charCode <= 57)"
          [(ngModel)]="teamOrder" placeholder="Enter order" required autocomplete="off">
      </div>

      <div class="main-section">
        <p class="errorMessage" *ngIf="uploadFileExtensionUser"> You can only upload jpg, jpeg, png files</p>
        <p class="errorMessage" *ngIf="chapterBoardEmailValid"> Enter valid email</p>

      </div>

      <div class="clear"></div>

      <div class="btn-div1 alignment">
        <button type="submit" id="saveBoard" name="chapterBoardForm" class="btn btn-danger margin-save"
          [disabled]="!chapterBoardForm.valid || chapterBoardEmailValid  || uploadUserPicImageDone || uploadFileExtensionUser"
          *ngIf="saveBoard">SAVE</button>
        <button name="saveAndUpdateBoard" id="saveAndUpdateBoard" class="btn btn-danger margin-save"
          *ngIf="saveAndUpdateBoard"
          [disabled]="!chapterBoardForm.valid  || uploadUserPicImageDone || chapterBoardEmailValid || uploadFileExtensionUser">SAVE
          AND UPDATE</button>
        <button type="button" class="btn btn-danger margin-save" name="chapterBoardForm"
          (click)="resetBoard()">RESET</button>
        <button type="button" class="btn btn-danger margin-save" (click)="openAndCloseMatDialog('close')">CLOSE</button>
      </div>
    </form>
  </div>
</ng-template>